module.exports = __webpack_public_path__ + "img/brands-barilla-production.jpg?058833f43cfe302c20a071036cd643a8";